import React, { useState } from 'react';
import useClickOutside from '../../../hooks/useClickOutside';
import { useRef } from 'react';
import styles from '../Header.module.css';
import airdaoIcon from '../assets/airdao.svg';
// import circleCheck from '../assets/circle-check.svg';
import copyIcon from '../assets/copy.svg';
import logoutIcon from '../assets/logout.svg';
export default function AddressInfo(_a) {
    var address = _a.address, balance = _a.balance, logout = _a.logout, close = _a.close, isOpen = _a.isOpen;
    var _b = useState(false), copied = _b[0], setCopied = _b[1];
    var ref = useRef(null);
    useClickOutside(ref, close, isOpen);
    var copy = function () {
        navigator.clipboard.writeText(address);
        setCopied(true);
        setTimeout(function () { return setCopied(false); }, 2000);
    };
    return (React.createElement("div", { className: styles['address-info'], ref: ref },
        React.createElement("div", { className: styles['address-info__block-wrapper'] },
            React.createElement("div", { className: styles['address-info__block'] },
                React.createElement("span", { className: styles['address-info__address'] }, address &&
                    "".concat(address.substring(0, 5), "...").concat(address.substring(address.length - 5, address.length))),
                React.createElement("span", { style: !copied ? { display: 'none' } : {}, className: styles['address-info__copied'] }, "Address copied!"),
                React.createElement("img", { src: copyIcon, width: "20", height: "20", onClick: copy, style: copied ? { display: 'none' } : {}, className: styles['address-info__copy'], alt: "copy" }))),
        React.createElement("div", { className: styles.balance },
            React.createElement("img", { src: airdaoIcon, width: "20", height: "20", className: styles.balance__img, alt: "airdao-icon" }),
            React.createElement("span", null,
                balance,
                " AMB")),
        React.createElement("hr", null),
        React.createElement("button", { className: styles['address-info__disconnect'], onClick: logout },
            React.createElement("img", { src: logoutIcon, width: "20", height: "20", alt: "logout" }),
            "Disconnect wallet")));
}
//# sourceMappingURL=AddressInfo.js.map